import React from 'react';
import { useIntl } from 'react-intl-next';
import CodeBidiWarning from '@atlaskit/code/bidi-warning';
import { codeBidiWarningMessages } from '@atlaskit/editor-common/messages';
import codeBidiWarningDecorator from '@atlaskit/code/bidi-warning-decorator';
export var useBidiWarnings = function useBidiWarnings(_ref) {
  var _ref$enableWarningToo = _ref.enableWarningTooltip,
    enableWarningTooltip = _ref$enableWarningToo === void 0 ? true : _ref$enableWarningToo;
  var intl = useIntl();
  var warningLabel = intl.formatMessage(codeBidiWarningMessages.label);
  var renderBidiWarnings = function renderBidiWarnings(text) {
    return codeBidiWarningDecorator(text, function (_ref2) {
      var bidiCharacter = _ref2.bidiCharacter,
        index = _ref2.index;
      return /*#__PURE__*/React.createElement(CodeBidiWarning, {
        bidiCharacter: bidiCharacter,
        key: index,
        label: warningLabel,
        tooltipEnabled: enableWarningTooltip
      });
    });
  };
  return {
    renderBidiWarnings: renderBidiWarnings,
    warningLabel: warningLabel
  };
};